// src/components/WinsAutosLogo.jsx
import React from "react";

const DEFAULTS = {
  accent: "#FF7A00", // Orange
  base: "#0A1A2B",   // Dark Blue
};

const WINS_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/wins-logo.png`;

function ImageMark({ size = 64, className }) {
  return (
    <img
      src={WINS_LOGO_SRC}
      alt="WINS AUTOS"
      width={size}
      height={size}
      className={`shrink-0 rounded-full object-cover ${className ?? ""}`}
      draggable={false}
    />
  );
}

// Emblem (icon)
function Emblem({ size = 64, accent = DEFAULTS.accent, base = DEFAULTS.base, rounded = true, className }) {
  const radius = rounded ? 16 : 8;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width={size} height={size} className={className}>
      <rect x="0" y="0" width="256" height="256" rx={radius} fill={base} />
      <path d="M24 184c32-44 64-66 104-66s72 22 104 66" fill="none" stroke={accent} strokeOpacity={0.15} strokeWidth={22} strokeLinecap="round"/>
      <path d="M40 72l36 116 52-84 52 84 36-116" fill="none" stroke="#FFFFFF" strokeWidth={18} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M128 92v72" fill="none" stroke={accent} strokeWidth={10} strokeLinecap="round" strokeDasharray="10 18"/>
      <path d="M256 196v60h-60c28-8 52-32 60-60z" fill={accent} />
    </svg>
  );
}

// Wordmark (text logo)
function Wordmark({ size = 32, base = DEFAULTS.base, className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 680 120" height={size} className={className}>
      <g fill={base}>
        <path d="M6 18h24l16 68 16-68h24l16 68 16-68h24l-28 88H98L82 46 66 106H34L6 18z" />
        <path d="M206 30c-22 0-38 16-38 40s16 40 38 40 38-16 38-40-16-40-38-40zm0 22c10 0 16 8 16 18s-6 18-16 18-16-8-16-18 6-18 16-18z" />
        <path d="M262 34h22v14c6-10 14-16 26-16 4 0 8 1 12 2v22c-4-2-8-3-12-3-16 0-26 12-26 32v22h-22V34z" />
        <path d="M342 18h22v88h-22V18z" />
        <path d="M390 74l-8 32h-24l30-88h28l30 88h-24l-8-32h-24zm20-18-8-28-8 28h16z" />
        <path d="M492 18h22v54c0 12 6 18 18 18 4 0 8-1 12-2v20c-6 2-12 2-18 2-22 0-34-12-34-34V18z" />
        <path d="M586 50h-20V34h62v16h-20v56h-22V50z" />
        <path d="M640 70c0-26 16-40 40-40 10 0 20 2 28 6v20c-8-4-16-6-24-6-12 0-22 8-22 20s10 20 22 20c8 0 16-2 24-6v20c-8 4-18 6-28 6-24 0-40-14-40-40z" />
      </g>
    </svg>
  );
}

// Main Logo Component
function WinsAutosLogo({ variant = "mark", size = 64, accent = DEFAULTS.accent, base = DEFAULTS.base, rounded = true, className }) {
  if (variant === "word") {
    return <Wordmark size={size} base={base} className={className} />;
  }

  if (variant === "full") {
    return (
      <div className={"flex items-center gap-3 " + (className ?? "")}>
        <ImageMark size={size} />
        <Wordmark size={size * 0.6} base={base} />
      </div>
    );
  }

  if (variant === "svg") {
    return <Emblem size={size} accent={accent} base={base} rounded={rounded} className={className} />;
  }

  return <ImageMark size={size} className={className} />;
}

export default WinsAutosLogo;
